import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Stack, Divider } from "@mui/material";
import TableChartIcon from "@mui/icons-material/TableChart";
import Header from "../Components/layout/Header";
import { API } from "../conf";
import { Context } from "../App";

export default function RapportAnnuel() {
    const { updateConnect, exercice } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const [loading, setLoad] = useState(false)
    const [clotures, setClotures] = useState([])
    const [pdf, setPdf] = useState()

    const eglise = useMemo(() => organisation && organisation.type === 'église' ? organisation : eglises.find(el => el._id === egliseId), [egliseId, eglises, organisation])

    const allMonthsClosed = clotures.length === 12

    function authHeaders() {
        return {
            Accept: 'application/pdf',
            'Content-Type': 'application/pdf',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
    }

    function handleToken(response) {
        const token = response.headers.get('x-auth-token')
        if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return false }
        if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
        return true
    }

    function handlePreRapport() {
        setPdf()
        if (!eglise?._id) return
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise._id}/pre_rapport_annuel?exercice=${exercice}`), {method: 'GET', headers: authHeaders()})
            .then(async response => {
                if (!handleToken(response)) return
                if (response.status === 200) setPdf(URL.createObjectURL(await response.blob()))
                setLoad(false)
            })
    }

    function handleRapportDefinitif() {
        setPdf()
        if (!eglise?._id) return
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise._id}/rapport_annuel/${exercice}`), {method: 'GET', headers: authHeaders()})
            .then(async response => {
                if (!handleToken(response)) return
                if (response.status === 200) setPdf(URL.createObjectURL(await response.blob()))
                setLoad(false)
            })
    }

    function exportRecapExcel() {
        if (!eglise?._id) return
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise._id}/recap_annuel?exercice=${exercice}`), {
            method: 'GET',
            headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token')}
        }).then(async response => {
            if (!handleToken(response)) return
            if (response.status === 200) {
                const {lignes, eglise: nomEglise, exercice: annee} = await response.json()
                const columns = ['Label', 'FEAM %', 'FEAM Montant (€)', 'ÉGLISE %', 'ÉGLISE Montant (€)', 'Total (€)']
                const header = columns.map(c => `"${c}"`).join(';')
                const rows = lignes.map(l => [
                    `"${l.label}"`,
                    l.feam_pct !== null ? String(l.feam_pct).replace('.', ',') : '',
                    String(l.feam.toFixed(2)).replace('.', ','),
                    l.eglise_pct !== null ? String(l.eglise_pct).replace('.', ',') : '',
                    String(l.eglise.toFixed(2)).replace('.', ','),
                    String(l.total.toFixed(2)).replace('.', ','),
                ].join(';'))
                const csv = [header, ...rows].join('\r\n')
                const blob = new Blob(['﻿' + csv], {type: 'text/csv;charset=utf-8;'})
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `RECAP_${nomEglise.replace(/\s+/g, '_').toUpperCase()}_${annee}.csv`
                a.click()
                URL.revokeObjectURL(url)
            }
            setLoad(false)
        })
    }

    function handleReedit() {
        setPdf()
        if (!eglise?._id) return
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise._id}/rapport_annuel/${exercice}/reedit`), {method: 'GET', headers: authHeaders()})
            .then(async response => {
                if (!handleToken(response)) return
                if (response.status === 200) setPdf(URL.createObjectURL(await response.blob()))
                setLoad(false)
            })
    }

    function getClotures() {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/years/${exercice}`), {
            method: 'GET',
            headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token')}
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return }
            if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
            if (response.status === 200) setClotures(await response.json())
            setLoad(false)
        })
    }

    useEffect(() => {
        if (eglise?._id) {
            setPdf()
            getClotures()
        }
    }, [eglise])

    useEffect(() => {
        if (organisation && organisation.type === 'fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length > 0 ? {_id: {$in: agent.eglises}} : {type: 'église'})}`), {
                method: 'GET',
                headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token')}
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if (response.status === 401) { sessionStorage.clear(); updateConnect(false); return }
                if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
                if (response.status === 200) { setEglises(await response.json()); setLoad(false) }
            })
        }
    }, [organisation])

    useEffect(() => {
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    }, [])

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
            <Header/>
            <Typography sx={{textAlign: 'center', marginTop: '20px', fontSize: 26}}>Rapport annuel</Typography>

            {organisation && organisation.type === 'fédération' && (
                <TextField select size="small" label="église" sx={{alignSelf: 'end', marginBottom: 3, width: '25%', marginRight: 3, minWidth: '200px'}}
                    value={egliseId}
                    onChange={e => setEgliseId(old => { if (old !== e.target.value) { setPdf(); setClotures([]) } return e.target.value })}>
                    {eglises.map(eg => <MenuItem key={eg._id} value={eg._id}>{`${eg.nom} - ${eg.commune.toUpperCase()}`}</MenuItem>)}
                </TextField>
            )}

            {eglise && (
                <Box sx={{paddingX: '20px', marginTop: '30px', display: 'flex', flexDirection: 'column', flex: 1}}>
                    <Stack direction='row' spacing={2} sx={{marginBottom: '25px', alignItems: 'center'}}>
                        {!allMonthsClosed && (
                            <Button variant="contained" onClick={handlePreRapport}>
                                Générer un rapport temporaire
                            </Button>
                        )}
                        {allMonthsClosed && (
                            <Button variant="contained" onClick={handleRapportDefinitif}>
                                Rapport définitif {exercice}
                            </Button>
                        )}
                        {pdf && allMonthsClosed && (
                            <Button variant="outlined" onClick={handleReedit}>Rééditer</Button>
                        )}
                        <Divider orientation="vertical" flexItem/>
                        <Button variant="outlined" startIcon={<TableChartIcon/>} onClick={exportRecapExcel} disabled={!eglise}>
                            Exporter récapitulatif Excel
                        </Button>
                        <Typography variant="body2" color="text.secondary">
                            {allMonthsClosed
                                ? `Exercice ${exercice} — 12/12 mois clôturés`
                                : `Exercice ${exercice} — ${clotures.length}/12 mois clôturés`}
                        </Typography>
                    </Stack>

                    {!loading && pdf && (
                        <embed src={pdf} width='100%' height='100%' type="application/pdf" style={{marginTop: 20, minHeight: '800px'}}/>
                    )}
                </Box>
            )}

            <Backdrop open={loading}><CircularProgress color="inherit"/></Backdrop>
        </div>
    )
}
